<template>
  <div
    v-if="fields"
    class="enrollment-banner"
  >
    <div
      v-if="!fields.enrollmentReminderBackgroundBlended"
      class="primary line"
    />
    <v-row
      justify="center"
      class="banner-row"
      no-gutters
    >
      <v-col
        lg="4"
        md="6"
        sm="8"
        xs="12"
      >
        <div
          class="banner-body white--text"
          :style="{ 'margin-top': fields.enrollmentReminderBackgroundBlended || fields.fullWidth ? '0': '45px' }"
        >
          <div
            v-if="fields.fullWidth"
            :class="(fields.enrollmentReminderBackgroundBlended)
              ? backgroundColorClass(fields.enrollmentReminderBackground)
              : 'primary'"
            :style="{ bottom: (fields.enrollmentReminderBackgroundBlended) ? '-140px': 0 }"
            class="full"
          />
          <div
            class="pos-rel"
            :class="[
              { 'dark-grey': fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'gold' },
              { 'white': fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple' },
              { 'primary': !fields.enrollmentReminderBackgroundBlended }
            ]"
          >
            <h4
              class="enrollment-title"
              :class="
                fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                  ? 'info--text'
                  : 'white--text'
              "
            >
              {{ fields.text ? fields.text : 'Enrollment for Medicare Advantage begins' }} <br/> {{ fields.deadline | formatDate('MMMM DD') }}
            </h4>
            <div class="time-tickers">
              <div class="d-flex flex-column">
                <span
                  :class="[
                    { 'animate-in': showAnimatedTicks && oldDiff.days },
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ timeDiff.days }}
                </span>
                <span
                  v-if="showAnimatedTicks && oldDiff.days"
                  class="animate-out"
                  :class="[
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ oldDiff.days }}
                </span>
                <div
                  class="time-label"
                  :class="[
                    fields.enrollmentReminderBackground === 'purple'
                      ? 'border-secondary'
                      : 'border-gold',
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text',
                    { 'border-neon-green': fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple' }
                  ]"
                >
                  days
                </div>
              </div>
              <div class="d-flex flex-column">
                <span
                  :class="[
                    { 'animate-in': showAnimatedTicks && oldDiff.days },
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ timeDiff.hours > 0 ? timeDiff.hours : 0 }}
                </span>
                <span
                  v-if="showAnimatedTicks && oldDiff.hours"
                  class="animate-out"
                  :class="[
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ oldDiff.hours }}
                </span>
                <div
                  class="time-label"
                  :class="[
                    fields.enrollmentReminderBackground === 'purple'
                      ? 'border-secondary'
                      : 'border-gold',
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text',
                    { 'border-neon-green': fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple' }
                  ]"
                >
                  hrs
                </div>
              </div>
              <div class="d-flex flex-column">
                <span
                  :class="[
                    { 'animate-in': showAnimatedTicks && oldDiff.days },
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ timeDiff.minutes > 0 ? timeDiff.minutes : 0 }}
                </span>
                <span
                  v-if="showAnimatedTicks && oldDiff.minutes"
                  class="animate-out"
                  :class="[
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text'
                  ]"
                >
                  {{ oldDiff.minutes }}
                </span>
                <div
                  class="time-label"
                  :class="[
                    fields.enrollmentReminderBackground === 'purple'
                      ? 'border-secondary'
                      : 'border-gold',
                    fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple'
                      ? 'primary--text'
                      : 'white--text',
                    { 'border-neon-green': fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'purple' }
                  ]"
                >
                  mins
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="fields.enrollmentReminderSignUp"
          class="email-container pa-5"
          :class="backgroundColorClass(fields.enrollmentReminderBackground)"
        >
          <h2 class="h5"
            :class="fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'gold' ? 'black--text' : 'white--text'"
          >
            Sign up for next-step enrollment reminders
          </h2>
          <div
            :class="fields.enrollmentReminderBackgroundBlended && fields.enrollmentReminderBackground === 'gold' ? 'black--text' : 'white--text'">
            <v-label for="email">
              Email
            </v-label>
          </div>
          <base-input
            v-model="email"
            name="email"
            color="primary"
            placeholder="Enter your email address"
            class="cutout"
            email
            arrow
            @submit="dialog = true"
            ref="emailInput"
          />
        </div>
      </v-col>
    </v-row>
    <email-dialog
      v-model="dialog"
      :email-received="email"
    />
  </div>
</template>

<script>
import * as moment from 'moment'
import EmailDialog from '@/components/dialogs/email-dialog'
import { backgroundColorClass } from '@/utils/helpers'

// TODO: fix this so its not disgusting, sorry, quick and dirty fam
export default {
  name: 'EnrollmentBanner',
  components: {
    EmailDialog
  },
  props: {
    fields: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      timeDiff: {
        days: 0,
        hours: 0,
        minutes: 0
      },
      oldDiff: {
        days: 0,
        hours: 0,
        minutes: 0
      },
      showAnimatedTicks: false,
      dialog: false,
      email: ''
    }
  },
  created () {
    this.durationDiff()
    setInterval(() => this.durationDiff(), 1 * 60 * 1000)
  },
  mounted () {
    this.setEmailAriaLabels()
  },
  methods: {
    backgroundColorClass,
    durationDiff () {
      if (!this.fields.deadline) {
        return
      }

      const now = moment()
      const exp = moment(this.fields.deadline)

      const timeDiff = {}
      timeDiff.days = this.noNegative(exp.diff(now, 'days'))
      timeDiff.hours = this.noNegative(exp.subtract(timeDiff.days, 'days').diff(now, 'hours'))
      timeDiff.minutes = this.noNegative(exp
        .subtract(timeDiff.hours, 'hours')
        .diff(now, 'minutes'))

      this.animateTicks(timeDiff, this.timeDiff)
      this.timeDiff = timeDiff
    },
    noNegative (num) {
      return num < 0 ? 0 : num
    },
    animateTicks (newTime, oldTime) {
      this.oldDiff = {
        days: 0,
        hours: 0,
        minutes: 0
      }
      if (newTime.days !== oldTime.days) {
        this.oldDiff.days = oldTime.days
      }
      if (newTime.hours !== oldTime.hours) {
        this.oldDiff.hours = oldTime.hours
      }
      if (newTime.minutes !== oldTime.minutes) {
        this.oldDiff.minutes = oldTime.minutes
      }
      this.showAnimatedTicks = true
      setTimeout(() => {
        this.showAnimatedTicks = false
      }, 490)
    },
    setEmailAriaLabels () {
      // Kind of a hack, but vuetify does not currently pass the aria-label set on a v-text-field through to the icons that act as submit buttons
      var emailSubmitBtn = document.querySelector('.email-container .v-input__icon--append button')
      if (emailSubmitBtn) {
        emailSubmitBtn.setAttribute('aria-label', 'Submit email address for next step enrollment reminders')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.enrollment-banner {
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
  z-index: 1;

  .banner-body {
    position: relative;
    z-index: 4;
    .enrollment-title {
      position: absolute;
      text-align: center;
      bottom: 150px;
      width: 100%;
      @media (max-width: $breakpoint-xxxs){
        font-size: $font-default-size;
      }
      @media (min-width: $breakpoint-xxxs) and (max-width: $breakpoint-xxs){
        font-size: $font-large;
      }
      @media (min-width: $breakpoint-xxs) and (max-width: $breakpoint-sm){
        font-size: $font-x-large;
      }
    }
    .time-tickers {
      padding-top: 100px;
      div {
        position: relative;
        text-align: center;
        span:first-child {
          font-size: 60px;
        }
        .time-label {
          width: 100px;
          font-size: 24px;
          position: relative;
          z-index: 100;
          padding-top: 8px;
          padding-bottom: 20px;
        }
      }
      width: 100%;
      height: 100%;
      min-height: 250px;
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
    }

    .full {
      position: absolute;
      width: 200vw;
      top: 0;
      bottom: 0;
      left: -50vw;
    }
  }

  .border-secondary {
    border-top: 2px solid $secondary !important;
    border-bottom: none;
  }
  .border-gold {
    border-top: 2px solid $gold !important;
    border-bottom: none;
  }
  .border-neon-green {
    border-top: 2px solid $neon-green !important;
    border-bottom: none;
  }

  .email-container {
    position: relative;
    z-index: 100;
    width: 100%;
    height: 140px;
    padding-top: 10px !important;
  }

  .line {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
    height: 15px;
    z-index: 3;
  }

  .animate-out {
    position: absolute;
    font-size: 60px;
    z-index: 5;
    left: 15px;
    animation: slide-out 0.5s ease-out;
  }

  .animate-in {
    position: relative;
    animation: slide-in 0.5s ease-out;
  }

  @keyframes slide-out {
    0% {
      top: 0px;
      opacity: 1;
    }
    100% {
      top: 100px;
      opacity: 0;
    }
  }

  @keyframes slide-in {
    0% {
      top: -100px;
      opacity: 0;
    }
    100% {
      top: 0;
      opacity: 1;
    }
  }
}
</style>
